import { render, staticRenderFns } from "./MxTextEditor.vue?vue&type=template&id=c63a96ec"
import script from "./MxTextEditor.vue?vue&type=script&lang=ts"
export * from "./MxTextEditor.vue?vue&type=script&lang=ts"
import style0 from "./MxTextEditor.vue?vue&type=style&index=0&id=c63a96ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports